//* * PALETA DE COLORES LARIDAE
/* Los colores declarados en constantes simplifican los futuros cambios
 /* ya que solo deben cambiarse en este documento y no en todos los que
 /* sea utilizado.
 **/

export const COLORES = {
  blue: {
    primary: '#3f51b5',
    primaryDark: '#273585',
    dark: '#172054',
    medium: '#3262cd',
    light: '#3f51b5'
  },
  green: {
    dark: '#49af4d',
    medium: '#58b05b',
    light: '#63c563'
  },
  grey: {
    light: '#d8d8d8',
    mediumLight: '#eeeeee',
    mediumDark: '#5b5b5b',
    dark: '#4c4c4c'
  },
  indigo: {
    suave: '#9fa8da',
    fuerte: '#283593'
  },
  lightGreen: {
    suave: '#c5e1a5',
    fuerte: '#558b2f'
  },
  orange: {
    medium: '#e39613',
    dark: '#de6e02'
  },
  pink: {
    suave: '#f48fb1',
    fuerte: '#ad1457'
  },
  red: {
    light: '#ef9a9a',
    dark: '#c62828',
    medium: '#ea443b',
    suave: '#ef9a9a',
    fuerte: '#c62828'
  },
  success: '#49af4d',
  error: '#ef9a9a',
  warning: '#f59707',
  black: '#272727',

  violet: '#835f91'

}

// Rangos segun stock en kg.
const RANGOS_STOCK = [
  {
    min: Number.NEGATIVE_INFINITY,
    max: -1,
    color: '#dc3545'

  },
  {
    min: 0,
    max: 8000,
    color: '#ff6c34'
  },
  {
    min: 8000,
    max: 15000,
    color: '#f57222'
  },
  {
    min: 15000,
    max: 20000,
    color: '#f7a145'
  },
  {
    min: 20000,
    max: 35000,
    color: '#e7cb36'
  },
  {
    min: 35000,
    max: 45000,
    color: '#42c152'
  },
  {
    min: 40000,
    max: Number.POSITIVE_INFINITY,
    color: '#44bb53'
  }
]

export function obtenerColorStock (stock) {
  const rango = RANGOS_STOCK.find((r) => stock >= r.min && stock < r.max)
  if (!rango) {
    return {
      backgroundColor: COLORES.grey.light,
      color: '#2d2d2d'
    }
  }

  let intensity = 0
  const hex2rgba = (hex, alpha) => {
    const r = Number.parseInt(hex.slice(1, 3), 16)
    const g = Number.parseInt(hex.slice(3, 5), 16)
    const b = Number.parseInt(hex.slice(5, 7), 16)
    return `rgb(${r}, ${g}, ${b}, ${alpha})`
  }

  if (rango.min === Number.NEGATIVE_INFINITY) {
    intensity = 0.8
  } else if (rango.min === 0) {
    intensity = 1 - (stock - rango.min) / (rango.max - rango.min)
  } else if (rango.max !== Number.POSITIVE_INFINITY && rango.min !== Number.NEGATIVE_INFINITY) {
    intensity = (stock - rango.min) / (rango.max - rango.min)
  } else {
    intensity = Math.min((stock - rango.min) / 50000000, 1)
  }

  const alpha = 0.4 + intensity * 0.6
  return {
    backgroundColor: hex2rgba(rango.color, alpha),
    color: '#2d2d2d'
  }
}

const RANGO_ESPACIO = [
  {
    min: Number.NEGATIVE_INFINITY,
    max: -1,
    color: '#dc3545'

  },
  {
    min: 0,
    max: 100,
    color: '#f57222'
  },
  {
    min: 100,
    max: 300,
    color: '#f7a145'
  },
  {
    min: 300,
    max: 500,
    color: '#e7cb36'
  },
  {
    min: 500,
    max: Number.POSITIVE_INFINITY,
    color: '#44bb53'
  }
]

export function obtenerColorEspacio (espacio) {
  const rango = RANGO_ESPACIO.find((r) => espacio >= r.min && espacio < r.max)
  if (!rango) {
    return COLORES.grey.light
  }
  return rango.color
}
